// src/components/Auth/Logout.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, firebaseSignOut } from "../../firebase";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function Logout() {
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    async function doSignOut() {
      setLoading(true);
      setErr("");
      try {
        await firebaseSignOut(auth);
        console.log("User signed out successfully");
        nav("/login");
      } catch (error) {
        console.error("Sign out error:", error.code, error.message);
        setErr("Unable to sign out. Please try again.");
      } finally {
        setLoading(false);
      }
    }
    doSignOut();
  }, [nav]);

  return (
    <div style={{ padding: 20 }}>
      {loading ? (
        <LoadingSpinner />
      ) : err ? (
        <div style={{ textAlign: "center", padding: "20px", color: "#b91c1c" }}>
          {err}
          <p>
            If you are not redirected automatically,{" "}
            <button
              onClick={() => {
                nav("/login");
              }}
            >
              click here
            </button>
            .
          </p>
        </div>
      ) : (
        <>
          <h2>Signing out…</h2>
          <p>
            If you are not redirected automatically,{" "}
            <button
              onClick={() => {
                nav("/login");
              }}
            >
              click here
            </button>
            .
          </p>
        </>
      )}
    </div>
  );
}